import { FIELDS_OF_STUDY } from "shared/pages/projectEdit/FieldsOfStudy";
import { TeamsList } from './teams';

export const projectStatus = [1, 10];
export const ROOT_ROUTE = '/';
export const DEFAULT_DESIGN_MAIN_ACTIVE_TAB = 'designers';
export const DEFAULT_MEDIA_ACTIVE_TAB = 'writers';
export const CONTEXT_START_FROM_ROOT = ['hsealumni', 'dafes', 'research', 'ageytomesh', 'main_geo', 'art_geo', 'art_deziiign', 'events_geo', 'creative_geo', 'academy_geo', 'places_geo'];
export const TEAMS_CONTEXTS = TeamsList;
export const CONTEXTS_WHERE_BTNS_HIDDEN = ['sound_deziiign', 'research', 'courses', 'design_geo', 'hse', 'main_geo', 'events_geo', 'art_geo', 'art_deziiign', 'places_geo', 'academy_geo', 'creative_geo', 'dafes', 'hsealumni', 'dpo',];
export const DARK_THEME = ['hsealumni', 'design_geo', 'art_geo', 'places_geo', 'main_geo', 'education_geo', 'events_geo', 'creative_geo', 'academy_geo'];
export const GEO_CONTEXTS = ['main_geo', 'dafes', 'hsealumni', 'design_geo', 'events_geo', 'places_geo', 'education_geo', 'art_geo', 'creative_geo', 'academy_geo'];
export const CONTEXT_WHERE_CANNOT_CREATE_PROJECT = ['hsealumni', 'dafes']
export const SUBSCRIPTION_CONTEXTS = ['hsegallery', 'hsestore']
export const MAIN_MEDIIIA_CONTEXT_ID = '0254ebb7241c4ea58dd36cd8b925088c';
export const ALL_CHANNELS_TEAM_ID = '314a7371e97b4e13805e255c3e3e45be';
export const TEAM_WITH_EXTERNAL_TEAM_EDIT = "3843f01365444e6bb3f2b88904029c17";
export const MEDIA_BLOG_SHOWCASE_TEAM_ID = "314a7371e97b4e13805e255c3e3e45be";
export const MAIN_FR_PAGE_TEAM_ID = 'e04ceb60a2bf42da8c8f66c836a81095';
export const PARIS_FR_PAGE_TEAM_ID = '3f09bead0b594067937fb966e9f9e613';
export const MARSEILLE_FR_PAGE_TEAM_ID = '2f8a84dfcb94408e98c004cdd1d53c6f';
export const SAOPAULO_FR_PAGE_TEAM_ID = '14616630c6db455dad1c27fbafbc70dc';
export const MUMBAI_FR_PAGE_TEAM_ID = '035186edce04473f9c233f504a646d68';
export const KOLKATA_FR_PAGE_TEAM_ID = '7a3f74a629304adeb04ede213aff7e61';
export const DUBAI_FR_PAGE_TEAM_ID = '009eca8826204fa9b01d929efb928e19';
export const SHANGHAI_FR_PAGE_TEAM_ID = '1a29e49f623d467484e8c6d88da3405c';

export const isFrShowcasePage = (teamId: string) => {
  return [
    // PARIS_FR_PAGE_TEAM_ID, 
    // MARSEILLE_FR_PAGE_TEAM_ID, 
    // SAOPAULO_FR_PAGE_TEAM_ID, 
    // MUMBAI_FR_PAGE_TEAM_ID, 
    // KOLKATA_FR_PAGE_TEAM_ID, 
    // DUBAI_FR_PAGE_TEAM_ID, 
    // SHANGHAI_FR_PAGE_TEAM_ID,
    MAIN_FR_PAGE_TEAM_ID
  ].includes(teamId);
}
export const examTabs = FIELDS_OF_STUDY.map(({
  label,
  value,
}) => ({
  path: value,
  name: label,
  filter: {
    contexts: [value]
  }
}))import { FIELDS_OF_STUDY } from "shared/pages/projectEdit/FieldsOfStudy";
import { TeamsList } from './teams';

export const projectStatus = [1, 10];
export const ROOT_ROUTE = '/';
export const DEFAULT_DESIGN_MAIN_ACTIVE_TAB = 'designers';
export const DEFAULT_MEDIA_ACTIVE_TAB = 'writers';
export const CONTEXT_START_FROM_ROOT = ['hsealumni', 'dafes', 'research', 'ageytomesh', 'main_geo', 'art_geo', 'art_deziiign', 'events_geo', 'creative_geo', 'academy_geo', 'places_geo'];
export const TEAMS_CONTEXTS = TeamsList;
export const CONTEXTS_WHERE_BTNS_HIDDEN = ['sound_deziiign', 'research', 'courses', 'design_geo', 'hse', 'main_geo', 'events_geo', 'art_geo', 'art_deziiign', 'places_geo', 'academy_geo', 'creative_geo', 'dafes', 'hsealumni', 'dpo',];
export const DARK_THEME = ['hsealumni', 'design_geo', 'art_geo', 'places_geo', 'main_geo', 'education_geo', 'events_geo', 'creative_geo', 'academy_geo'];
export const GEO_CONTEXTS = ['main_geo', 'dafes', 'hsealumni', 'design_geo', 'events_geo', 'places_geo', 'education_geo', 'art_geo', 'creative_geo', 'academy_geo'];
export const CONTEXT_WHERE_CANNOT_CREATE_PROJECT = ['hsealumni', 'dafes']
export const SUBSCRIPTION_CONTEXTS = ['hsegallery', 'hsestore']
export const MAIN_MEDIIIA_CONTEXT_ID = '0254ebb7241c4ea58dd36cd8b925088c';
export const ALL_CHANNELS_TEAM_ID = '314a7371e97b4e13805e255c3e3e45be';
export const TEAM_WITH_EXTERNAL_TEAM_EDIT = "3843f01365444e6bb3f2b88904029c17";
export const MEDIA_BLOG_SHOWCASE_TEAM_ID = "314a7371e97b4e13805e255c3e3e45be";
export const MAIN_FR_PAGE_TEAM_ID = 'e04ceb60a2bf42da8c8f66c836a81095';
export const PARIS_FR_PAGE_TEAM_ID = '3f09bead0b594067937fb966e9f9e613';
export const MARSEILLE_FR_PAGE_TEAM_ID = '2f8a84dfcb94408e98c004cdd1d53c6f';
export const SAOPAULO_FR_PAGE_TEAM_ID = '14616630c6db455dad1c27fbafbc70dc';
export const MUMBAI_FR_PAGE_TEAM_ID = '035186edce04473f9c233f504a646d68';
export const KOLKATA_FR_PAGE_TEAM_ID = '7a3f74a629304adeb04ede213aff7e61';
export const DUBAI_FR_PAGE_TEAM_ID = '009eca8826204fa9b01d929efb928e19';
export const SHANGHAI_FR_PAGE_TEAM_ID = '1a29e49f623d467484e8c6d88da3405c';

export const isFrShowcasePage = (teamId: string) => {
  return [
    // PARIS_FR_PAGE_TEAM_ID, 
    // MARSEILLE_FR_PAGE_TEAM_ID, 
    // SAOPAULO_FR_PAGE_TEAM_ID, 
    // MUMBAI_FR_PAGE_TEAM_ID, 
    // KOLKATA_FR_PAGE_TEAM_ID, 
    // DUBAI_FR_PAGE_TEAM_ID, 
    // SHANGHAI_FR_PAGE_TEAM_ID,
    MAIN_FR_PAGE_TEAM_ID
  ].includes(teamId);
}
export const examTabs = FIELDS_OF_STUDY.map(({
  label,
  value,
}) => ({
  path: value,
  name: label,
  filter: {
    contexts: [value]
  }
}))